import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'MFI',
  version: 1,
  label: 'Money Flow Index',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 210,
  inputs: [period('timeperiod', 14)],
  outputs: [line('mfi', 'MFI', COLOR.purple)],
  levels: [{ value: 80 }, { value: 20 }],
  talib: { functions: ['MFI'], expr: 'MFI(high, low, close, volume, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
